import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'saleOrderList',
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectable: {
      type: Boolean,
      default: false
    },
    selectedId: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    selected: {
      get: function get() {
        return this.selectedId;
      },
      set: function set(val) {
        this.$emit('update:selectedId', val);
      }
    },
    sendTypeMap: function sendTypeMap() {
      return {
        1: '实体卡/券',
        2: '虚拟卡/券',
        3: '电子码',
        4: '搭售'
      };
    }
  },
  methods: {
    // 电影次卡（业务类型 4）的售卡信息用次数口径
    isTimes: function isTimes(row) {
      return Number(row.card_bin_group_id) === 4;
    },
    satisfactionType: function satisfactionType(row) {
      return {
        0: 'warning',
        1: 'success'
      }[Number(row.satisfaction_survey_status)] || '';
    }
  }
};